/* Massimo Castelli 12.10.2026 - Private label builder, step 03: adds a photo of each logo finish to the buttons.
   Photos come from Content > Files (mc-logo-blind/gold/silver-12.10.2026.jpg). If a photo is missing the button stays text-only. */
(function () {
  var root = document.getElementById('mcpl');
  if (!root) return;
  var FILES = root.getAttribute('data-files-base') || '';
  /* Shopify adds _2 to a file name when that name was already used: try both */
  var IMG = {
    'Blind hot stamp': ['mc-logo-blind-12.10.2026_2.jpg', 'mc-logo-blind-12.10.2026.jpg'],
    'Gold foil': ['mc-logo-gold-12.10.2026_2.jpg', 'mc-logo-gold-12.10.2026.jpg'],
    'Silver foil': ['mc-logo-silver-12.10.2026_1.jpg', 'mc-logo-silver-12.10.2026.jpg', 'mc-logo-silver-12.10.2026_2.jpg']
  };
  var st = document.createElement('style');
  st.textContent =
    '.mcpl-logo{padding:0;overflow:hidden;display:flex;flex-direction:column}' +
    '.mcpl-logo__img{display:block;aspect-ratio:2/1;background:#efe9e1;overflow:hidden;border-bottom:1px solid rgba(var(--color-foreground),.12)}' +
    '.mcpl-logo__img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s}' +
    '.mcpl-logo:hover .mcpl-logo__img img{transform:scale(1.04)}' +
    '.mcpl-logo__img--none{display:flex;align-items:center;justify-content:center;font-size:3.2rem;opacity:.45}' +
    '.mcpl-logo b,.mcpl-logo>span:not(.mcpl-logo__img){padding:0 1.8rem}' +
    '.mcpl-logo b{margin-top:1.4rem}' +
    '.mcpl-logo>span:last-child{padding-bottom:1.8rem}';
  document.head.appendChild(st);

  function decorate() {
    var box = document.getElementById('mcpl-logos');
    if (!box) return;
    var btns = box.querySelectorAll('.mcpl-logo[data-logo]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.querySelector('.mcpl-logo__img')) continue;
      var name = b.getAttribute('data-logo');
      var wrap = document.createElement('span');
      if (IMG[name] && FILES) {
        wrap.className = 'mcpl-logo__img';
        var im = document.createElement('img');
        im.loading = 'lazy';
        im.alt = name + ' example';
        im.setAttribute('data-try', '0');
        im.setAttribute('data-names', IMG[name].join('|'));
        im.src = FILES + IMG[name][0] + '?width=700';
        im.onerror = function () {
          var names = this.getAttribute('data-names').split('|'), k = +this.getAttribute('data-try') + 1;
          if (k < names.length) { this.setAttribute('data-try', String(k)); this.src = FILES + names[k] + '?width=700'; return; }
          var p = this.parentNode; if (p && p.parentNode) p.parentNode.removeChild(p);
        };
        wrap.appendChild(im);
      } else {
        wrap.className = 'mcpl-logo__img mcpl-logo__img--none';
        wrap.textContent = '?';
      }
      b.insertBefore(wrap, b.firstChild);
    }
  }
  decorate();
  /* the builder re-renders the buttons on every click, and some apps rewrite the page HTML: watch the whole page */
  var queued = false;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; decorate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  var n = 0, t = setInterval(function () { decorate(); if (++n > 20) clearInterval(t); }, 500);
})();
